package co.maytes.standupbot.dashboard.pages.oauth

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import co.maytes.standupbot.dashboard.stores.ToastKind
import co.maytes.standupbot.dashboard.stores.rememberUiStore
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText

/**
 * Linear OAuth callback. The backend has already stored the Linear token
 * before redirecting here. Unlike the Slack flow we don't need a fresh
 * access-token bootstrap; we just toast + advance the user to the next
 * onboarding step.
 */
@Page("/oauth/linear-callback")
@Composable
fun LinearCallbackPage() {
    val ctx = rememberPageContext()
    val ui = rememberUiStore()

    LaunchedEffect(Unit) {
        val error = ctx.route.params["error"]
        if (error != null) {
            ui.showToast("Linear connect failed: $error", ToastKind.Error)
            ctx.router.navigateTo("/app/onboarding/linear")
            return@LaunchedEffect
        }
        ui.showToast("Linear connected", ToastKind.Success)
        ctx.router.navigateTo("/app/onboarding/team")
    }

    Box(
        modifier = Modifier.fillMaxSize().padding(Spacing.xxl),
        contentAlignment = Alignment.Center,
    ) {
        SpanText(
            text = "Finishing Linear connection…",
            modifier = Modifier.fontSize(Typography.body.size),
        )
    }
}
